
import VimeoPlayer from '@vimeo/player';
import { CONSTS, INFO } from '../util/object';


// CANVAS ANNOATAION CLASS
//    - generic drawing routine, pass in canvas context
//    - pass in distance in %, object will scale it
//    - supports dual buffer
//
export class AnnotationClass {
    _canvas = null;     // currently active
    _canvas0 = null;
    _canvas1 = null;
    _ctx = null;        // currently active
    _ctx0 = null;       // copy to prime
    _ctx1 = null;        // write to buffer
    _url = null;

    _width = null;
    _height = null;
    _scale_x = null;
    _scale_y = null;
    _offset_y = 0;    // kludge: to tweak youtube extra y space to hide "play next"

    
    constructor(canvas, width, height) {
        if(canvas !== null){
            var context = canvas.getContext("2d");
            console.log("annotate.17:             +  +  +  +  CREATE NEW ANNOTATION OBJECT  BUFFER   width=",width," height=",height,"  ",canvas);
            
            this._canvas1 = canvas;
            this._ctx1 = context;

            this._width = parseInt(width);
            this._height = parseInt(height);
            this._scale_x = this._width / CONSTS.DISPLAY_BASE_X;    // Note: switch to WEBCAM_BASE_WIDTH?
            this._scale_y = this._height / CONSTS.DISPLAY_BASE_Y;

            this._canvas = this._canvas1;   // default
            this._ctx = this._ctx1;         // default
        }
    }

    set offset_y(offset) {
        this._offset_y = parseInt(offset);
        //console.log("annotate.35:   ------ SET ANNOTATE   height=",height);
    }
    get offset_y() {
        return this._offset_y;
    }


    set ctx_height(height) {
        this._height = parseInt(height);
        //console.log("annotate.35:   ------ SET ANNOTATE   height=",height);
    }
    get ctx_height() {
        return this._height;
    }

    set ctx_width(width) {
        this._width = parseInt(width);
        this._scale_x = this._width / CONSTS.DISPLAY_BASE_X;
        this._scale_y = this._height / CONSTS.DISPLAY_BASE_Y;
        //console.log("annotate.35:   ------ SET ANNOTATE   width=",width);
    }
    get ctx_width() {
        return this._width;
    }


    // select which buffer to write to
    //
    set canvas(id) {
        if (id === 0) {
            this._canvas = this._canvas0;
            this._ctx = this._ctx0;
        } else {
            this._canvas = this._canvas1;
            this._ctx = this._ctx1;
        }
    }


    set canvas1(canvas) {
        this._canvas1 = canvas;
        var context = canvas.getContext("2d");
        this._ctx1 = context;
    }
    set ctx1(ctx) {
        this._ctx1 = ctx;
    }
    get ctx1() {
        return this._ctx1;
    }
    get canvas1() {
        return this._canvas1;
    }


    set canvas0(canvas) {
        this._canvas0 = canvas;
        var context = canvas.getContext("2d");
        this._ctx0 = context;
    }
    get canvas0() {
        return this._canvas0;
    }
    get ctx0() {
        return this._ctx0;
    }


    set url(url) {
        this._url = url;
    }
    get url() {
        return this._url;
    }


    // get the scale
    get scalex() {
        return this._scale_x;
    }
    get scaley() {
        return this._scale_y;
    }



    // generic position parsing
    //    - "%" percent of frame
    //    - [+, -] "px": offset from edg, eplus is from zero, minus from end 
    //
    calc_pos(pos, max) {
        var out = 0;
        var numb = parseInt(pos.match(/\d+/g));     // extract numbers only

        //console.log("annotate.42:     CALC POS  pos=",pos,  "  max=",max);
        if(pos.includes("%")) {
            if(pos[0] === "-") {
                out = max - ((numb / 100) * max);
            } else {
                out = (numb / 100) * max;
            }
            //console.log("annotate.46:     CALC POS %    pct=",numb,  " max=",max, "  out=",out);

        } else if(pos.includes("px")) {
            if(pos[0] === "-") {
                out = max - numb;
            } else {
                out = numb;
            }
            //console.log("annotate.49:     CALC POS PX offset=",numb,  "  out=",out);
        } else {
            out = numb;
        }

        //console.log("annotate.88:         CALC POS NORMAL  pos=",pos, " max=",max, " out=",out);
        return parseInt(out);
    }

    calc_x(xpos) {
        var pos = this.calc_pos(xpos.toString(), this._width);
        //var pos = this.calc_pos(xpos.toString(), this._canvas.width);
        return pos;
    }

    //
    calc_y(ypos) {
        var pos = this.calc_pos(ypos.toString(), (this._height - this._offset_y));
        //console.log("annotate.46:     CALC POS Y %   ypos=",ypos,"  ht=",this._height,  " offset_y=",this._offset_y, "  out=",pos);
        return pos;
    }

    scale_x(isize) {
        var osize = this.calc_pos(isize.toString(), this._width);
        var size = osize * this._scale_x;
        return parseInt(size);
    }

    scale_y(isize) {
        var osize = this.calc_pos(isize.toString(), this._height);
        var size = osize * this._scale_y;
        return parseInt(size);
    }

    //
    // display a text label
    //    - x & y are %
    //
    draw_text(color, bgcolor, fsize, olabel, xpos, ypos, justify) { 
        var x = this.calc_x(xpos);
        var y = this.calc_y(ypos);
        var size = this.scale_x(fsize);
        var label = olabel.toString();
        var cap = label.replace(/[^A-Z]/g, "").length;  // caps are wider

        const mx = this.scale_x(4);
        const my = this.scale_y(3);
        var fscale = fsize / 15;

        // first adjust to screen scale, then adjust by font size
        //
        //var w = (this.scale_x(label.length*8.3) + (cap*1.4) + (mx*2)) * fscale;
        //var w = (this.scale_x((label.length*8.6)+(cap*0.6)) + (mx*2)) * fscale;
        var w = (this.scale_x((label.length*8.2)+(cap*0.7)) + (mx*2)) * fscale;     // @15
        var h = (this.scale_y(12) + (my*2)) * fscale;
        var shift = (justify === "center") ? (w / 2) : 0;

        this._ctx.fillStyle = (bgcolor === null) ? "#000000a0": bgcolor;    // default to black
        //this._ctx1.fillRect(x-mx, y+h+my, w+(mx*2), -h-(my*2));
        //this._ctx.fillRect(x-mx, y+h+my, w, -h);
        this._ctx.fillRect(x-(mx + shift), y+h+my, w, -h);
        (false || INFO.mock_debug) && console.log("annotate.76:     DRAW TEXT  ",label, " xpos=",xpos, " ypos=",ypos,"   x=",x, "  y=",y,  " max_x=",this._width, " max_y=",this._height);

        //INFO.mock_debug && console.log("annotate.76:     DRAW TEXT  ht=",this._height, " wd=",this._width, " ypos=",ypos, " xpos=",xpos, "  ctx=",this._ctx);
        this._ctx.fontWeight = "normal";
        this._ctx.strokeStyle = "black"
        this._ctx.font = size.toString()+"px arial";
        this._ctx.strokeText(label, (x - shift), y+h);		// use fillStyle
        this._ctx.fillStyle = color
        this._ctx.fillText(label, (x - shift), y+h);		// use fillStyle

    }


    // display an ellipse
    //
    draw_ellipse(color, border, line_width, xpos, ypos, ow, oh) {
        var x = this.calc_x(xpos);
        var y = this.calc_y(ypos);
        var w = this.scale_x(ow);
        var h = this.scale_y(oh);

        this._ctx.lineWidth = line_width;
        this._ctx.fillStyle = color;
        this._ctx.strokeStyle = border;
        this._ctx.beginPath();       // Start a new path
        this._ctx.ellipse(x, y, w, h, 0, 0, Math.PI*2);
        this._ctx.fill();
        this._ctx.stroke();
    }


    // display a solid block
    //    - x, y is at the center of the bar
    //
    draw_block(color, xpos, ypos, ow, oh) {
        //console.log("annotate.183:     DRAW BLOCK0     xpos=",(xpos),"  ypos=",(ypos),  " ow=",ow, " oh=",oh);
        var x = this.calc_x(xpos);
        var y = this.calc_y(ypos);
        var w = this.scale_x(ow);
        var h = this.scale_y(oh);
        var w2 = w/2;
        var h2 = h/2;
        //console.log("annotate.190:     DRAW BLOCK     xpos=",xpos, " ypos=",ypos, " x=",(x-w2),"  y=",(y-h2),  " w=",w, " h=",h);

        //context.lineWidth = width;
        this._ctx.fillStyle = color
        this._ctx.fillRect(x-w2, y-h2, w, h);
    }




}


